import actions from './actions';

const { setAuthParams, clearAuthParams } = actions;

/**
 * Action creator to set auth parameters (client_id and institute_id) in Redux store
 * @param {string} clientId - The client identifier
 * @param {string} instituteId - The institute identifier
 */
const setAuthParamsAction = (clientId, instituteId) => {
    return (dispatch) => {
        console.log('[Redux] Setting auth params:', { client_id: clientId, institute_id: instituteId });
        
        // Also store in sessionStorage as backup (persists across redirects)
        if (clientId) {
            sessionStorage.setItem('client_id', clientId);
        }
        if (instituteId) {
            sessionStorage.setItem('institute_id', instituteId);
        }
        
        dispatch(setAuthParams(clientId, instituteId));
    };
};

/**
 * Action creator to clear auth parameters from Redux store
 */
const clearAuthParamsAction = () => {
    return (dispatch) => {
        console.log('[Redux] Clearing auth params');
        dispatch(clearAuthParams());
    };
};

export { setAuthParamsAction, clearAuthParamsAction };

